export function TrialLoadingIcon() {
	return (
		<div className="h-[40px] w-[40px] mt-4 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 relative">
			<div className="absolute bottom-[13px] right-0 w-2.5 h-2.5 bg-bc-blue rounded-full animate-up" />
			<div className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-bc-blue rounded-full" />
			<div className="absolute bottom-0 right-[13px] w-2.5 h-2.5 bg-bc-blue rounded-full animate-left" />
		</div>
	)
}
